import { GET_PROFILE, GET_UPDATEPROFILE } from "resources/actionTypes";

export function getProfile(payloadType) {
  const data = {
    payloadType: payloadType,
  };

  return {
    type: GET_PROFILE.GET_PROFILE_REQUESTED,
    payload: data,
  };
}

export function patchUpdateProfile(userUpdateProfile) {
    const data ={
      userUpdateProfile:userUpdateProfile,
    }
    return {
      type: GET_UPDATEPROFILE.GET_UPDATEPROFILE_REQUESTED,
      payload: data,
    };
  }
